import isObject from 'lodash/isObject';
import { bool, string } from 'prop-types';
import React from 'react';
import { Alert } from 'reactstrap';

import { allStatusesEnum } from '../campaigns/constants';
import { campaignShape } from '../prop-types';
import UpdateCampaign from './UpdateCampaign';

function renderFieldLevelErrors(key, message) {
  return Object.entries(message).map(([field, error]) => (
    <li key={field}>
      <div>{key}</div>
      <div>
        ({field}: {error})
      </div>
    </li>
  ));
}

function getHumanReadableErrors(errorObj) {
  return (
    <ul className="list-unstyled">
      {Object.entries(errorObj).map(([key, message]) =>
        !isObject(message) ? (
          <li key={key}>{message}</li>
        ) : (
          renderFieldLevelErrors(key, message)
        ),
      )}
    </ul>
  );
}

function WaitForCampaignCreation(props) {
  const campaign = props.initialCampaign;

  if (campaign.status === allStatusesEnum.CREATING.value) {
    return (
      <Alert color="info">
        The campaign is still prepared. Please refresh in a few seconds.
      </Alert>
    );
  }

  if (campaign.status === allStatusesEnum.CREATION_FAILED.value) {
    return (
      <>
        <Alert color="danger">
          {getHumanReadableErrors(campaign.updateError)}
        </Alert>
        Please resolve the error in the opportunity or quote, then recreate the
        campaign.
      </>
    );
  }

  return <UpdateCampaign {...props} />;
}

WaitForCampaignCreation.propTypes = {
  initialCampaign: campaignShape.isRequired,
  view: string,
  isEditing: bool,
};

WaitForCampaignCreation.defaultProps = {
  view: null,
  isEditing: false,
};

export default WaitForCampaignCreation;
